import { Routes } from '@angular/router';
import { NeedLoginGuard } from 'src/app/common/need-login.guard';
import { ExternalSettingsResolver } from 'src/app/common/services/external-settings/external-settings-resolver.service';
import { RootComponent } from 'src/app/root/root.component';
import { AppModeGuard } from './app-mode.guard';

export const SHARED_ROUTES: Routes = [
  {
    path: 'contact-us',
    loadChildren: () => import('../../business/contact-us/contact-us.module').then(m => m.ContactUsModule),
    data: { public: true }
  },
  {
    path: 'mobile-location-map',
    loadChildren: () => import('../../business/mobile-location-map/mobile-location-map.module').then((m) => m.MobileLocationMapModule),
  },
];

export const PUBLIC_ROUTES: Routes = [
  {
    // IFrame for mobile IOS handling
    path: 'video-player',
    loadChildren: () => import('../../business/video-player/video-player.module').then(m => m.VideoPlayerModule),
  },
  {
    path: '',
    component: RootComponent,
    resolve: [ExternalSettingsResolver],
    canActivate: [NeedLoginGuard],
    canActivateChild: [AppModeGuard],
    children: [
      ...SHARED_ROUTES,
      {
        path: 'forgot-password',
        loadChildren: () => import('../../business/forgot-password/forgot-password.module').then((m) => m.ForgotPasswordModule),
      },
      {
        path: 'license-viewer',
        loadChildren: () => import('../../business/license-viewer/license-viewer.module').then((m) => m.LicenseViewerModule),
      },
      {
        path: 'login',
        loadChildren: () => import('../../business/login/login.module').then((m) => m.LoginModule),
      },
      {
        path: 'demo/login',
        loadChildren: () => import('../../business/demo-login/demo-login.module').then((m) => m.DemoLoginModule),
      },
      {
        path: 'self-registration/:state',
        loadChildren: () => import('../../business/self-registration/self-registration.module').then((m) => m.SelfRegistrationModule),
      },
    ],
  }

];